import { FIELD_TYPE_OPERATORS, OperatorType } from '../config'
import { FilterCondition } from '../types'
import { SchemaAttribute, SchemaAttributes } from '@/Data/types'

interface UpdateFieldResult {
  operator: string
  value: unknown
}

export function calculateFieldUpdate(
  currentCondition: FilterCondition,
  newField: string,
  baseSchemaAttributes: SchemaAttributes | null,
): UpdateFieldResult {
  const oldAttribute = baseSchemaAttributes?.[currentCondition.field]
  const oldFieldType = getFieldType(currentCondition.field, oldAttribute)

  const newAttribute = baseSchemaAttributes?.[newField]
  const newFieldType = getFieldType(newField, newAttribute)

  const newOperators = FIELD_TYPE_OPERATORS[newFieldType] || []
  const currentOperator = currentCondition.operator as OperatorType

  const operatorStillValid = newOperators.includes(currentOperator)

  if (operatorStillValid) {
    return {
      operator: currentOperator,
      value: shouldPreserveValue(currentOperator, oldFieldType, newFieldType)
        ? currentCondition.value
        : null,
    }
  }

  return {
    operator: newOperators[0] || 'eq',
    value: null,
  }
}

function getFieldType(
  field: string,
  attribute: SchemaAttribute | undefined,
): string {
  if (field === '_id') return 'reference'
  return attribute?.type || 'string'
}

function shouldPreserveValue(
  operator: string,
  oldFieldType: string,
  newFieldType: string,
): boolean {
  if (operator === 'empty' || operator === 'notEmpty') {
    return true
  }

  if (oldFieldType === newFieldType) return true

  const compatibleTypes = [
    ['string', 'string'],
    ['integer', 'integer'],
    ['date', 'datetime'],
    ['datetime', 'date'],
  ]

  return compatibleTypes.some(
    ([type1, type2]) =>
      (oldFieldType === type1 && newFieldType === type2) ||
      (oldFieldType === type2 && newFieldType === type1),
  )
}
